export default {
    init() {
        document.querySelectorAll('.accordion').forEach(accordion => { 
            function toggle_accordion() {
                if(accordion.classList.contains('up')) {
                    accordion.classList.add('down')
                    accordion.classList.remove('up')
                } else {
                    accordion.classList.remove('down')
                    accordion.classList.add('up')
                }
                
                /* Toggle between hiding and showing the active panel */
                let content = accordion.nextElementSibling;
                // console.log("Sibling: ", this);
                if (content.style.display === "block") {
                    content.style.display = "none";
                } else {
                    content.style.display = "block";
                }

                document.activeElement.blur();
            }
            
            accordion.addEventListener('click', (e) => {
                toggle_accordion();
            });

            accordion.addEventListener('keydown', (e) => {
                if(e.keyCode === 13) {
                    toggle_accordion();
                    e.preventDefault();
                }
            })
        });
    }
}